import React from "react";

// components
import Paginate from "../../../components/ui/paginate";
import OpportunityCard from "../misc/OpportunityCard";

// state
import { get_opportunities } from "../../../service/api/opportunity";
import { onNext, onBack } from "../../../store/slices/opportunity";
import { setTitle } from "../../../store/slices/navbar";
import { useAppDispatch, useAppSelector } from "../../../store";
import { Loader } from "../../../components/animation/Loader";

const Opportunity = () => {
  const dispatch = useAppDispatch();
  const last_page = useAppSelector(({ opportunity }) => opportunity.last_page);
  const current_page = useAppSelector(
    ({ opportunity }) => opportunity.current_page,
  );
  const opportunities = useAppSelector(
    ({ opportunity }) => opportunity.opportunities,
  );

  const loading = useAppSelector(({ opportunity }) => opportunity.loading);

  const onLoad = React.useCallback(() => {
    dispatch(setTitle("Opportunity"));
    get_opportunities(dispatch, current_page);
  }, [current_page, dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (loading) {
    return (
      <div className="grid place-content-center h-[90svh]">
        <Loader />
      </div>
    );
  }

  return (
    <div className="">
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 pb-12">
          {opportunities.map((item) => (
            <OpportunityCard key={item.id} item={item} />
          ))}
        </div>
        <Paginate
          current_page={current_page}
          last_page={last_page}
          onBack={() => dispatch(onBack())}
          onNext={() => dispatch(onNext())}
        />
      </div>
    </div>
  );
};

export default Opportunity;
